import AvatarAndPill from '../avatar/Avatar'
import LogoGradientIcon from '../../icons/LogoGradientIcon'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectUser, setSession } from '../../reducers/users'
import { SessionState } from '../../types/UserTypes'
import { inPov } from '../../utils/session'

interface IHeaderProps {
  pageTitle?: string
}

const Header = (props: IHeaderProps) => {
  const { pageTitle } = props
  const navigate = useNavigate()
  const { session, currentPage } = useSelector(selectUser)
  const dispatch = useDispatch()

  useEffect(() => {
    const goToConfigured = localStorage.getItem('SSO_CONFIGURED_COOKIE')

    if (goToConfigured === 'true') {
      navigate('/settings')
    }
    if (window.location.search.includes('error=sso-unauthorized')) {
      navigate('/sso-error')
    }
  }, [])

  useEffect(() => {
    const storedSession = localStorage.getItem('session') as string

    if (currentPage === 'SSO_ERROR') {
      localStorage.setItem('session', '{}')
      localStorage.removeItem('SSO_CONFIGURED_COOKIE')
      dispatch(setSession(undefined))
    } else if (!session && storedSession === '{}' && currentPage !== 'SSO_ERROR') {
      localStorage.setItem('session', '{}')
      localStorage.removeItem('SSO_CONFIGURED_COOKIE')
      dispatch(setSession(undefined))
      navigate('/login')
    } else if (!session && storedSession !== '{}') {
      dispatch(setSession(JSON.parse(storedSession) as SessionState))
    }
  }, [session])

  useEffect(() => {
    if (import.meta.env.VITE_PRETTY_ENV !== 'Production' && import.meta.env.VITE_ON_PREM === 'false') {
      document.title = '[' + import.meta.env.VITE_PRETTY_ENV + '] ' + 'iVerify EDR Portal'
    }
  }, [])

  return (
    <div className="w-full absolute h-[74px] flex" style={{ top: inPov(session) ? '42px' : '0px' }}>
      {/* iVerify Logo */}
      <div className="h-[26px] flex items-center mt-6 ml-6 w-[182px]">
        <LogoGradientIcon height="26" width="71" />
      </div>
      <div className="flex items-center flex-grow">
        {/* Page Title */}
        {pageTitle && <div className="font-semibold text-black dark:text-white text-xl ml-4">{pageTitle}</div>}
      </div>
      {/* Avatar */}
      <AvatarAndPill />
    </div>
  )
}

export default Header
